import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  ValidateNested,
  IsNumber,
  IsBoolean,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
interface AccountResponse {
  avatar: string;
  email: string;
  username: string;
  id: string;
  vipType: number;
  nowVipType: string;
  now_is_subscription: number;
  nowVipType_subscription_id: string;
  history_last_subscription_id: string;
  is_team_master: boolean;
  team_code: string;
  latest_modified_workspace: {
    id: string;
  };
}

class LatestModifiedWorkspace {
  // @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;
}

export class AccountData {
  avatar?: string;

  @Required("Email cannot be empty")
  @IsString("Email must be a string")
  email: string;

  @Required("Username cannot be empty")
  @IsString("Username must be a string")
  username: string;

  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  // @Required("Team code cannot be empty")
  @IsString("Team code must be a string")
  teamCode: string;

  /** 是否会员： -1 非会员、 0 会员、1 会员过期 */
  // @Required("Vip type cannot be empty")
  @IsNumber("Vip type must be a number")
  vipType: number;

  /** 是否连续订阅： -1 已取消连续订阅、1 连续订阅中 */
  // @Required("Now is subscription cannot be empty")
  @IsNumber("Now is subscription must be a number")
  nowIsSubscription: number;

  /** 当前会员类型：miuta_starter、miuta_pro、miuta_premium */
  // @Required("Now vip type cannot be empty")
  @IsString("Now vip type must be a string")
  nowVipType: string;

  /** 当前订阅套餐ID */
  // @Required("Now vip type subscription id cannot be empty")
  @IsString("Now vip type subscription id must be a string")
  nowVipTypeSubscriptionId: string;

  /** 历史订阅套餐ID */
  // @Required("History last subscription id cannot be empty")
  @IsString("History last subscription id must be a string")
  historyLastSubscriptionId: string;

  @Required("Is team master cannot be empty")
  @IsBoolean("Is team master must be a boolean")
  isTeamMaster: boolean;

  // @Required("Latest modified workspace cannot be empty")
  @ValidateNested(LatestModifiedWorkspace)
  latestModifiedWorkspace: LatestModifiedWorkspace;
}

const transformAndValidateAccount = (
  response: AccountResponse
): AccountData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AccountData);
  } catch (error) {
    console.error("Account data validation failed:", error.message);
    throw error;
  }
};

const URL = "/users/profile";

// 获取用户信息
export const account = async (): Promise<AccountData> => {
  const response = await api.get<AccountResponse>(URL);
  const validatedData = transformAndValidateAccount(response.data);
  return validatedData;
};
